import Flickity from './wwdevFlickity';
import CustomNav from "./CustomNav";

class FlickityCarousel {
	constructor(config) {
		this.config = Object.assign({
			scope: '.flickity-carousel',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each(function (it, el) {
			let settings = this.defaultSettings();

			Object.keys($(el).data()).forEach(function (key) {
				Object.assign(settings, {[key]: $(el).data(key)});
			});

			let slider = new Flickity(el, settings);
			let $customNavScope = $(el).closest('[data-flickity-nav="scope"]');

			if($customNavScope.length < 1) {
				return;
			}

			new CustomNav({
				flickity: slider,
				scope: $customNavScope[0],
			})
		}.bind(this));
	}

	// Je kunt hier de standaard waardes aanpassen.
	defaultSettings() {
		return {
			cellAlign: 'left',
			contain: true,
			groupCells: true
		}
	}
}

export default FlickityCarousel;